import React, { useState, useRef } from "react";
import { useCart } from "../Context/Cartcontext";
import { useAuth } from "../Context/AuthContext";

import { useNavigate } from "react-router-dom";


const Cart = () => {

  const navigate = useNavigate();

  const { cartItems, removeFromCart, clearCart } = useCart();
  const [paymentData, setPaymentData] = useState(null);
  const [gatewayUrl, setGatewayUrl] = useState("");
  const formRef = useRef(null);
  const { user, authLoading } = useAuth();
  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Loading...
      </div>
    );
  }

  const handleCheckout = (e) => {
    e.preventDefault();
    if (formRef.current) formRef.current.submit();
  };
  // console.log("user testing", user);

  // ✅ Calculate total including GST
  const grandTotal = cartItems.reduce((acc, course) => {
    const gstPercent = parseFloat(course.gst_precent) || 0;
    const basePrice = parseFloat(course.course_price) || 0;
    const total =
      course.gst_flag === 0
        ? basePrice + (basePrice * gstPercent) / 100
        : basePrice;
    return acc + total;
  }, 0);

  return (
    <>
      <title>EDC - Cart</title>
      <meta
        name="description"
        content="Browse professional courses to upskill yourself in technology, business, and more."
      />
      <meta name="keywords" content="courses, learning, edc, education, skills" />
      <meta property="og:title" content="Courses - EDC Learning" />
      <meta property="og:description" content="Find the right course to upskill yourself." />
      <meta property="og:image" content="/images/LSClogo.png" />
      <meta property="og:url" content="https://edc.lsc-india.org/" />
      <meta name="twitter:card" content="summary_large_image" />

      <div className="min-h-screen py-10 px-4">
        <div className="max-w-6xl mx-auto">
          {cartItems.length > 0 && (
            <div className="flex justify-between items-center mb-2">
              <h1 className="text-2xl text-left">
                {cartItems.length} Course{cartItems.length > 1 ? "s" : ""} in cart
              </h1>

              <button
                className="text-sm text-red-600 font-medium hover:underline"
                onClick={clearCart}
              >
                Clear Cart
              </button>
            </div>
          )}


          <hr className="py-3" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

            {/* ------------- EMPTY CART (CENTERED) ------------- */}
            {cartItems.length === 0 ? (
              <div className="md:col-span-3 flex flex-col items-center justify-center py-20 bg-white rounded-xl">
                <img
                  src="/images/cart.jpg"
                  alt="Empty Cart"
                  className="w-80 md:w-96 opacity-90"
                />
                <p className="text-gray-600 mt-6 text-xl font-medium">
                  Your cart is empty
                </p>

                {/* Continue Shopping Button */}
                <button
                  onClick={() => navigate("/")}
                  className="mt-6 px-6 py-3 bg-[#5D4CCF] text-white rounded-md text-md font-semibold shadow-md hover:bg-purple-900 transition"
                >
                  ← Continue Learning
                </button>
              </div>
            ) : (

              /* ------------- LEFT: COURSE LIST ------------- */
              <div className="md:col-span-2 bg-white rounded-xl p-6 space-y-4">
                {cartItems.map((course, index) => {
                  const gstPercent = parseFloat(course.gst_precent) || 0;
                  const basePrice = parseFloat(course.course_price) || 0;
                  const totalPrice =
                    course.gst_flag === 0
                      ? basePrice + (basePrice * gstPercent) / 100
                      : basePrice;

                  return (
                    <div key={index} className="flex gap-4 items-start">
                      <img
                        src={`https://edcbackend.lsc-india.org/${course.image}`}
                        alt={course.course_name}
                        className="w-44 h-28 object-cover rounded-md"
                      />
                      <div className="flex-1">
                        <h2 className="text-lg font-semibold text-left">
                          {course.course_name}
                        </h2>

                        <p className="text-sm text-left text-gray-600 mt-0.5">
                          Category: {course.category_name}
                        </p>

                        <p className="text-sm text-left text-gray-700 mt-1">
                          {course.course_hrs} total hours
                        </p>

                        <div className="flex justify-between items-center mt-2">
                          <div className="text-[#4b0082] font-bold text-lg">
                            ₹{Math.round(totalPrice)}
                            {course.gst_flag === 0 && (
                              <small className="text-gray-600">
                                (incl. {gstPercent}% GST)
                              </small>
                            )}
                          </div>

                          <button
                            className="text-sm text-red-600 hover:underline"
                            onClick={() => removeFromCart(course.id)}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* ------------- RIGHT: PAYMENT BOX ------------- */}
            {cartItems.length > 0 && (
              <div className="bg-white rounded-xl p-6 border h-fit">
                <div className="flex justify-between text-lg font-semibold mb-2">
                  <span>Total:</span>
                 <span>₹{Math.round(grandTotal)}</span>
                </div>

                <hr className="border-t border-gray-300 my-4" />

                <form
                  action={`https://edcbackend.lsc-india.org/api/payment/pre-pay-process`}
                  method="POST"
                >
                  <input type="hidden" name="user_id" value={user?.id || ""} />

                  {cartItems.map((item, index) => (
                    <input
                      key={index}
                      type="hidden"
                      name="course_ids[]"
                      value={item.id}
                    />
                  ))}

                  <button
                    type="submit"
                    disabled={!user}
                    className="w-full bg-[#4b0082] text-white py-3 rounded-md text-md font-semibold hover:bg-purple-900 transition"
                  >
                    Proceed to Checkout →
                  </button>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Hidden auto-submit form */}
      {paymentData && (
        <form
          id="paymentForm"
          action={gatewayUrl}
          method="POST"
          style={{ display: "none" }}
        >
          {Object.entries(paymentData).map(([key, value]) => (
            <input key={key} type="hidden" name={key} value={value} />
          ))}
        </form>
      )}
    </>
  );
};

export default Cart;
